import { getData, handleErrors, postData } from "./common.service";

export async function getFarmUserAlternateMobile(farmUserId: string): Promise<string | null> {
    const qs = {
        where: { farmUserId },
        fields: { alternateMobile: true },
        limit: 1,
    };
    return getData("/farm-users?filter=" + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json()).then((users: any[]) => users?.[0]?.alternateMobile ?? null);
}

export async function getFarmUserIdsPaginated(text: string = "", skip: number = 0, limit: number = 20) {
    const qs = {
        where: {
            or:
                [
                    { farmUserId: { like: `.*${text}.*`, options: 'i' } },
                    { name: { like: `.*${text}.*`, options: 'i' } },
                ]
        },
        limit: limit,
        skip: skip,
        fields: {
            farmUserId: true,
            name: true
        }
    };
    return getData("/farm-users?filter=" + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((data) => data.json());
}

export async function getFarms(text: string = '', skip = 0) {
    const qs = {
        where: {
            or:
                [
                    { farmId: { like: `.*${text}.*`, options: 'i' } },
                    { name: { like: `.*${text}.*`, options: 'i' } },
                    { place: { like: `.*${text}.*`, options: 'i' } },
                    { taluka: { like: `.*${text}.*`, options: 'i' } },
                    { district: { like: `.*${text}.*`, options: 'i' } },
                    { farmUserId: { like: `.*${text}.*`, options: 'i' } }
                ]
        },
        order: 'created_date DESC',
        include: [{
            relation: 'farmUser',
            fields: {   
                name: true,
                mobile: true
            }
        }, {
            relation: 'plots',
            fields: {
                plotId: true,
                name: true
            }
        }],
        limit: 20,
        skip: skip
    };
    return getData('/farms?filter=' + JSON.stringify(qs), {

      sendTokenInHeader: true,
      basePath: process.env.REACT_APP_CORE_API_BASEPATH,
    }).then(data => data.json())
}

export async function getFarm(farmId: string) {
    return getData(`/farms/${farmId}`, {
      sendTokenInHeader: true,
      basePath: process.env.REACT_APP_CORE_API_BASEPATH,
    }).then(data => data.json())
}

export async function searchFarm(farmId: string){
    const qs = {
        'fields': {
            'farmId': true
        }
    }
    return getData(`/farms/${farmId}?filter=` + JSON.stringify(qs), { 
        sendTokenInHeader: true,
        basePath: process.env.REACT_APP_CORE_API_BASEPATH})
            .then(data => data.json())
            .catch((e) => console.log(e));
}
export async function getFarmIdsOfUser(farmUserId: string) {
    return getData(`/farms/farmuserid/${farmUserId}`, {
        sendTokenInHeader: true,
        basePath: process.env.REACT_APP_CORE_API_BASEPATH
    }).then(data => data.json())
}

export async function getPlotIdsOfFarm(farmId: string) {
    const qs = {
        where: { farmId },
        fields: { plotId: true, name: true },
    };
    return getData("/plots?filter=" + JSON.stringify(qs), {
        sendTokenInHeader: true,
        basePath: process.env.REACT_APP_CORE_API_BASEPATH
    }).then(data => data.json())
}

export async function registerFarm(farmData: any) {
    return postData('/farms/add', {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: farmData
    });
}

export async function updateFarm(farmData: any) {
    return postData('/farms/'+farmData.farmId, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: farmData,
        usePutMethod: true
    });
}

// Admin only: moves the farm and all its plots (with their devices and plans) to farmUserId
export async function transferFarm(farmId: string, farmUserId: string): Promise<{ farmId: string, farmUserId: string, plotsTransferred: number }> {
    return postData(`/farms/${farmId}/transfer`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: { farmUserId }
    }).then(handleErrors);
}

export async function postpubliclyAccessible(farmId: string, value: boolean) {
    return postData(`/farms/${farmId}/public`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        usePatchMethod: true,
        body: {
            value: value
        }
    })
}